<script setup>
import Swiper from 'swiper'
import {
    EffectFade,
    Pagination,
    Autoplay,
    Parallax,
    Keyboard,
    Navigation  // 添加Navigation模块
} from 'swiper/modules'

// 快捷方块数据
const props = defineProps({
    quick: {
        type: Array,
        required: true,
        default: () => [],
    },
})

// 初始化 Swiper
const initSwiper = () => {
    nextTick(() => {
        new Swiper('.swiper-container', {
            modules: [Pagination, Navigation, Autoplay], // 添加 Autoplay 模块
            loop: true,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            // 自动轮播配置
            autoplay: {
                delay: 3000, // 自动切换时间间隔，单位毫秒（3秒）
                disableOnInteraction: false, // 用户操作后是否停止自动切换
                pauseOnMouseEnter: true, // 鼠标悬停时暂停自动切换
            },
            // 可选的自动轮播相关配置
            speed: 500, // 切换动画速度（毫秒）
            breakpoints: {
                992: {
                    slidesPerView: 5,
                    spaceBetween: 30,
                },
                768: {
                    slidesPerView: 5,
                    spaceBetween: 30
                },
                576: {
                    slidesPerView: 5,
                    spaceBetween: 30
                }
            }
        })
    })
}

// 生命周期
onMounted(() => {

    initSwiper()
})
</script>

<template>
    <!-- 快捷方块3 -->
    <div class="Heziyun-blockBackground">
        <div class="Heziyun-quick3">
            <div class="swiper swiper-container">
                <div class="swiper-wrapper">
                    <div class="swiper-slide" v-for="(item, index) in quick" :key="item.id" style="width: 20%;">
                        <a :href="item.url" class="Heziyun-itemBlock"
                            v-intersect="{ class: 'bottom-top', delay: index * 40 }">
                            <div class="Heziyun-neirong">
                                <div class="Heziyun-picture">
                                    <a-image :src="item.img" show-loader :preview="false" />
                                </div>
                                <div class="Heziyun-text">
                                    <span>{{ item.title }}</span>
                                    <p>{{ item.tips }}</p>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="less" scoped>
// 快捷方块3
.Heziyun-blockBackground {

    .Heziyun-quick3 {
        width: 100%;
        margin: 0 auto;
        position: absolute;
        bottom: 0;
        z-index: 10;
        display: flex;
        align-items: flex-end;
        justify-content: center;
        flex-wrap: wrap;
        background: hsla(0, 0%, 100%, .5);
        -webkit-backdrop-filter: blur(8px);
        backdrop-filter: blur(8px);

        .swiper {
            width: 80rem;

            .swiper-slide {
                margin-right: 0 !important;
                width: 20% !important;
            }
        }

        .Heziyun-itemBlock {
            height: 6rem;
            width: 15rem;
            overflow: hidden;
            position: relative;
            flex-wrap: wrap;

            &:hover {
                background-color: hsla(0, 0%, 100%, .5);

                .Heziyun-neirong {

                    .Heziyun-text {

                        span {
                            color: #0056ff;
                        }
                    }
                }
            }

            .Heziyun-neirong {
                position: relative;
                height: 6rem;
                padding: 1rem;
                display: flex;
                align-items: center;
                gap: 1rem;

                .Heziyun-picture {
                    flex-shrink: 0;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    :deep(.arco-image-img) {
                        width: 2rem;
                        height: 2rem;
                        object-fit: contain;
                    }
                    :deep(.arco-image-loader-spin-text) {
                        display: none !important;
                    }
                }

                .Heziyun-text {
                    display: flex;
                    flex-direction: column;
                    gap: 0.3rem;

                    span {
                        color: #252b3a;
                        font-size: 1rem;
                        font-weight: 700;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 1;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }

                    p {
                        color: #4B5563;
                        font-size: 0.7rem;
                        display: -webkit-box;
                        /* 使用弹性盒子布局 */
                        -webkit-box-orient: vertical;
                        /* 设置内容垂直排列 */
                        -webkit-line-clamp: 2;
                        /* 限制显示的行数 */
                        overflow: hidden;
                        /* 隐藏超出部分 */
                        text-overflow: ellipsis;
                        /* 超出部分显示省略号 */
                    }
                }

                .Heziyun-linear {
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    background: linear-gradient(0deg, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0)), linear-gradient(90deg, #60A5FA 0%, #2563EB 100%);
                    width: 0%;
                    height: 0.15rem;
                }
            }
        }
    }
}

// 快捷方块3
@media (max-width: 768px) {
    .Heziyun-blockBackground {

        .Heziyun-quick3 {
            margin: 0;
            position: initial;
            gap: 3vw;
            padding: 5vw;
            background-color: #f3f5f8;

            .swiper {
                width: 100%;
                height: auto;


                .swiper-slide {
                    margin-right: 0 !important;
                    width: 100% !important;
                }
            }

            .Heziyun-itemBlock {
                height: auto;
                width: 100%;
                background-color: rgba(228, 238, 255, 0.43);
                background-image: linear-gradient(0deg, #fff, #f3f5f8);
                border: 2px solid #fff;
                box-shadow: 8px 8px 20px 0 rgba(55, 99, 170, .1);
                border-radius: 1vw;
                font-family: "思源黑";

                &:not(:last-child)::after {
                    display: none;
                }

                &:hover {
                    background-color: #fff;
                    height: 27vw;
                }

                .Heziyun-neirong {
                    position: relative;
                    height: 20vw;
                    padding: 3vw;
                    display: flex;
                    align-items: center;
                    gap: 2vw;

                    .Heziyun-picture {

                        :deep(.arco-image-img) {
                            width: 6vw;
                            height: 6vw;
                        }
                    }

                    .Heziyun-text {
                        gap: 1vw;

                        span {
                            font-size: 3.5vw;
                        }

                        p {
                            font-size: 3vw;
                            -webkit-line-clamp: 1;
                        }
                    }

                    .Heziyun-linear {
                        position: absolute;
                        bottom: 0;
                        left: 0;
                        background: linear-gradient(0deg, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0)), linear-gradient(90deg, #60A5FA 0%, #2563EB 100%);
                        width: 0%;
                        height: 0.15rem;
                    }
                }
            }
        }

        .Heziyun-quick> :last-child:nth-child(odd) {
            grid-column: 1 / -1;
        }
    }
}
</style>